<template>
  <v-app class="kitchenLines">
    <v-container fluid fill-height class="lines-page">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg5>
          <v-card class="pb-3">
            <v-card-title class="headline justify-center">
              Select Kitchen Line
            </v-card-title>

            <v-card-text>
              <v-layout wrap>
                <v-flex
                  xs12
                  md6
                  class="px-3"
                  v-for="line in lines"
                  :key="`role-${line.id}`"
                >
                  <v-btn
                    block
                    large
                    color="primary"
                    :outline="selectedLine.id != line.id"
                    @click="selectedLine = line"
                  >
                    {{ line.name }}
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-checkbox
                    v-model="restrict"
                    label="Restrict to KOT line"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-title class="justify-center">
              <v-btn color="error" class="elevation-0" @click="close()">Close</v-btn>
              <v-btn color="success" class="elevation-0" @click="submit(selectedLine)" :disabled="!Object.keys(selectedLine).length">Continue</v-btn>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<style>
.kitchenLines {
  overflow: hidden;
}

.lines-page {
  background-color: #0d7e83;
  background-image: url("./../../assets/pin_bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

.theme--light .lines-page  .v-btn.v-btn--outline {
  border: 1px solid #000;
  color: #000 !important;
}

.theme--dark .lines-page  .v-btn.v-btn--outline {
  border: 1px solid #fff;
  color: #fff !important;
}

</style>

<script>
import {
    clearLocalStorage
} from "@/providers/RoloProvider";

export default {
  name: "KitchenLines",
  data() {
    return {
      lines: [],
      storeId: localStorage.getItem("storeId"),
      restrict: false,
      selectedLine: {},
    };
  },
  methods: {
    close() {
      clearLocalStorage();
      this.$router.push({
        path: `login`,
      });
    },
    submit(kl) {
      localStorage.setItem("isLineRestricted", this.restrict);

      this.$store.dispatch("setKitchenLine", {
        kl
      });

      this.$router.push({
        path: `/store/${this.storeId}/home`,
      });
    },
    getKitchenLines() {
      let url = this.$apiURL + "store/" + this.storeId + "/kitchenLines";
      this.$http.get(url).then(function (resp) {
        // console.log(resp);
        this.lines = resp.body.lines || [];
        this.lines.unshift(this.chefMode());
      });
    },
    chefMode() {
      return {
        id: 0,
        kitchen_line_id: 0,
        kitchen_line_name: "Chef",
        name: "Chef",
        default: true,
        auto_accept: false,
      };
    },
  },
  created() {
    this.getKitchenLines();
  },
};
</script>
